// extracted by mini-css-extract-plugin
export default {"sectionContainer":"StatsSection_sectionContainer__jZ2zG","tableContainer":"StatsSection_tableContainer__uaMUR","subTitle":"StatsSection_subTitle__Hgor5"};